var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellNotificationSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f6d6e",
    fillRule: "nonzero",
    d: "M29.068 25.468c.002-1.594-.793-3.083-2.118-3.969v-4.436c0-3.761-2.99-6.927-6.663-7.058-1.877-.069-3.7.629-5.053 1.932-1.352 1.303-2.115 3.1-2.116 4.978v4.582c-1.325.886-2.12 2.376-2.118 3.97v1.382h5.613c.362 1.598 1.783 2.733 3.421 2.733 1.639 0 3.059-1.135 3.421-2.733h5.613v-1.381zm-9.034 2.523c-.761 0-1.451-.447-1.763-1.142h3.526c-.311.695-1.002 1.142-1.763 1.142zm-7.447-2.72c.066-1.098.692-2.085 1.658-2.611l.455-.182v-5.563c0-1.448.59-2.833 1.631-3.839 1.042-1.005 2.448-1.544 3.895-1.492 2.835.1 5.14 2.557 5.14 5.479v5.355l.418.223c.985.522 1.626 1.52 1.692 2.632l-14.89-.003z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellNotificationSelected);
export default __webpack_public_path__ + "static/media/BellNotificationSelected.84d081d2b877e9c750186ed6450e57d9.svg";
export { ForwardRef as ReactComponent };